import ResourceCrudPage, {
  Field,
  TextInput,
  TextArea,
  NumberInput,
} from "./ResourceCrudPage";

export default function AdminFaqsPage() {
  return (
    <ResourceCrudPage
      resource="faqs"
      title="FAQ"
      subtitle="Parent questions shown on the FAQ page. Reorder to control display order."
      testIdPrefix="faqs"
      blank={() => ({
        question: "",
        answer: "",
        display_order: 100,
        active: true,
      })}
      validate={(f) =>
        !f.question?.trim()
          ? { ok: false, message: "Question is required." }
          : !f.answer?.trim()
          ? { ok: false, message: "Answer is required." }
          : { ok: true }
      }
      renderRow={(item) => (
        <div>
          <p className="font-display font-bold text-slate-900 truncate">
            {item.question}
          </p>
          <p className="text-xs text-slate-500 mt-1 line-clamp-2">{item.answer}</p>
        </div>
      )}
      renderForm={({ form, setField }) => (
        <>
          <Field label="Question">
            <TextInput
              value={form.question}
              onChange={setField("question")}
              data-testid="faqs-form-question"
            />
          </Field>
          <Field label="Answer">
            <TextArea
              rows={6}
              value={form.answer}
              onChange={setField("answer")}
              data-testid="faqs-form-answer"
            />
          </Field>
          <Field label="Display order">
            <NumberInput
              value={form.display_order}
              onChange={setField("display_order")}
            />
          </Field>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={!!form.active}
              onChange={(e) => setField("active")(e.target.checked)}
            />
            Active (visible on public site)
          </label>
        </>
      )}
    />
  );
}
